import { writable } from 'svelte/store';
import collect from 'collect.js';
import config from '@/config.js';
// Models
import Competition from '@/Models/Competition.js';
import SportStore from '@/Stores/Sport/SportStore';
import { mergeCollectionStore } from '@/Stores/StoreHelpers.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	let _store;
	let meta;

	const { subscribe, set, update } = writable(collect());

	subscribe((current) => (_store = current));

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getCompetitionsForSport(sportId, pagination = null, reset = true, sportcastCompetition = false) {
			if (!config.SPORT_ENABLED) return;

			const competition = new Competition();
			competition.resourceUrl = () => {
				return `${competition.baseUrl()}/sports/${sportId}/competitions`;
			};
			let withs = ['market_group_set'];
			if (sportcastCompetition) {
				withs = ['market_group_set', 'sportcast_competition'];
			}
			let results = pagination
				? competition.with(withs).paginate(pagination.size, pagination.number)
				: competition.with(withs).get();
			return results
				.then((result) => {
					meta = result.meta;
					if (reset) {
						set(collect(result.data));
					} else {
						mergeCollectionStore(this, collect(result.data));
					}
				})
				.catch((e) => {
					console.error(e);
				});
		},

		updateCompetitionMarketGroupSet(competitionId, market_group_set_id = null) {
			if (!config.SPORT_ENABLED) return;

			let competition = _store.firstWhere('id', competitionId);
			return competition.patch({
				market_group_set_id
			});
		},

		createCompetition(data) {
			let competition = new Competition();

			return competition
				.makePersistRequest({
					url: `${competition.baseUrl()}/${competition.resourceName()}`,
					method: 'PUT',
					data
				})
				.then((result) => {
					SportStore.getSports(true);
					return result;
				});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
